import React, { useEffect, useState } from 'react'
import 'swiper/swiper-bundle.min.css';
import { Button } from 'react-bootstrap'
import buttonArow from '../assets/images/button-arrow-hover.svg'
import buttonArowWhite from '../assets/images/button-arrow.svg'
import { Link, useNavigate } from 'react-router-dom'
import Modal from 'react-bootstrap/Modal';
import { Col, Form, Row } from 'react-bootstrap'
import { Field, Formik } from 'formik';
import * as Yup from 'yup';
import { SEND_EMAIL } from '../api/constant'
import toast, { Toaster } from 'react-hot-toast';

const SignupSchema = Yup.object().shape({
  first_name: Yup.string()
    .min(2, 'Too Short!')
    .max(50, 'Too Long!')
    .required('First Name required'),
  last_name: Yup.string()
    .min(2, 'Too Short!')
    .max(50, 'Too Long!')
    .required('Last Name required'),
  message: Yup.string()
    .min(2, 'Too Short!')
    .max(500, 'Too Long!')
    .required('Required'),
  subject: Yup.string()
    .min(2, 'Too Short!')
    .max(50, 'Too Long!')
    .required('Required'),
  email: Yup.string()
    .email('Email Address is not valid')
    .required('Email is required'),

});

function EmailModal(props) {
  const [errMsg, setErrMsg] = useState(null)
  const navigate = useNavigate();



  return (
    <Modal
      {...props}

      aria-labelledby="contained-modal-title-vcenter"
      centered
      dialogClassName="modal-90w"
      className='connect-with-agent'>
      <Toaster
        position="top-center"
        reverseOrder={false}
        duration="50000"
      />
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <h2>Email Us <span className="common-grad"></span></h2>
        <Row>
          <Col>
            <Formik
              initialValues={{
                first_name: '',
                last_name: '',
                message: '',
                subject: '',
                email: '',
              }}
              validationSchema={SignupSchema}
              onSubmit={async (values, { resetForm }) => {
                // Submit Data
                const requestOptions = {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify(values)
                };
                const res = await fetch(SEND_EMAIL, requestOptions);
                const data = await res.json()
                if (data.status) {
                  toast.success(
                    'Your email has been sent successfully!! Our team will contact you soon',
                    { duration: 3000 }
                  );

                  resetForm({
                    values: {
                      first_name: '',
                      last_name: '',
                      message: '',
                      subject: '',
                      email: '',
                    }
                  })
                  setTimeout(() => {
                    props.onHide();
                    toast.dismiss();  
                  }, 1500);
                } else {
                  setErrMsg(data.message)
                  toast.error(data.message);
                }

              }}
            >
              {({ handleSubmit, handleChange, values, touched, errors }) => (<Form name="send-email" className='connect-with-agent-form' onSubmit={handleSubmit} >
                <Row>
                  <Col md={12} lg={6}>
                    <Form.Group controlId="validationFormik01">
                      <Form.Control type="text" placeholder="First Name *" name="first_name" value={values.first_name} onChange={handleChange} isInvalid={!!errors.first_name} />
                      <Form.Control.Feedback type="invalid">
                        {errors.first_name}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={12} lg={6}>
                    <Form.Group controlId="validationFormik02">
                      <Form.Control type="text" placeholder="Last Name *" name="last_name" value={values.last_name} onChange={handleChange} isInvalid={!!errors.last_name} />
                      <Form.Control.Feedback type="invalid">
                        {errors.last_name}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={12} lg={12} controlId="validationFormik06">
                    <Form.Group >
                      <Form.Control type="email" placeholder="Email *" name="email" value={values.email} onChange={handleChange} isInvalid={!!errors.email} />
                      <Form.Control.Feedback type="invalid">
                        {errors.email}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={12} lg={12} controlId="validationFormik06">
                    <Form.Group >
                      <Form.Control type="text" placeholder="Subject *" name="subject" value={values.subject} onChange={handleChange} isInvalid={!!errors.subject} />
                      <Form.Control.Feedback type="invalid">
                        {errors.subject}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={12} lg={12}>
                    <Form.Group controlId="validationFormik03">
                      <Form.Control as="textarea" rows={3} placeholder="Message *" name="message" value={values.message} onChange={handleChange} isInvalid={!!errors.message} />
                      <Form.Control.Feedback type="invalid">
                        {errors.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={12} lg={12}>
                    <Link className="cutom-button" onClick={handleSubmit} type="submit">Submit <img className='on-hover' src={buttonArow} alt="" /> <img className='defailt' src={buttonArowWhite} alt="" /></Link>
                  </Col>
                </Row>
              </Form>
              )}
            </Formik>
          </Col>
        </Row>
      </Modal.Body>
    </Modal >
  )
}

export default EmailModal;